import { Route, Routes } from 'react-router-dom';
import Toaster from './components/notifications/Toaster';
import './App.css';
import RouteContext from './components/routeContext';
import NotFoundPage from './pages/404';
import AdminPage from './pages/admin/admin';
import CompanyProfilePage from './pages/admin/companyProfile';
import EmployeesPage from './pages/admin/employees/employees';
import ServiceCategoriesPage from './pages/admin/serviceCategories';
import UsersPage from './pages/admin/users';
import CalendarPage from './pages/calendar/calendar';
import CashFlowPage from './pages/cashflow/cashflow';
import CashFlowTransactionsPage from './pages/cashflowTransactions/cashflowTransactions';
import ClientsPage from './pages/clients/clients';
import ClientDetailPage from './pages/clients/clientDetail';
import ExpenseTypesPage from './pages/expenseTypes/expenseTypes';
import ExpensesPage from './pages/expenses/expenses';
import HomePage from './pages/home';
import JobsPage from './pages/jobs/jobs';
import LoginPage from './pages/login';
import PayrollsPage from './pages/payrolls/payrolls';
import ProfilePage from './pages/profile/profile';
import RegisterPage from './pages/register';
import SalesPage from './pages/sales/sales';
import ServicesPage from './pages/services/services';
import MaterialsPage from './pages/materials/materials';
import MaterialReportsPage from './pages/reports/materialReports/materialReports';
import ThankYouPage from './pages/thankyou';
import VerifyEmailPage from './pages/verifyEmail';
import ForgotPasswordPage from './pages/forgotPassword';
import ResetPasswordPage from './pages/resetPassword';
import DashboardTemplate from './templates/dashboard';
import BadgesPage from './pages/admin/badges/badges';
import JobReportsPage from './pages/reports/jobReports/jobReports';
import SocketContext, { socket } from './context/socket';
import NotificationsPage from './pages/notifications/notifications';
import JobsPerformancePage from './pages/reports/jobReports/jobsPerformance';
import ExpensesReportsPage from './pages/reports/jobReports/expensesReports';
import ServicesReportsPage from './pages/reports/servicesReports/servicesReports';
import JobAssignees from './pages/reports/jobReports/jobAssignees';
import RoutePlanPage from './pages/routePlan/routePlan';
import PublicIntakePage from './pages/publicIntake';
import AcceptInvitePage from './pages/acceptInvite';
import TrackPage from './pages/track';
import PlatformLayout from './templates/platformLayout';
import PlatformDashboard from './pages/platform/platform';
import PlatformCompaniesPage from './pages/platform/companies';
import PlatformCompanyDetailPage from './pages/platform/companyDetail';
import PlatformUsersPage from './pages/platform/users';
import PlatformPlansPage from './pages/platform/plans';

function App(props) {

  return (
    <>
    <SocketContext.Provider value={socket}>
      <Toaster />
      <Routes>

        {/* Platform Owner Panel — separate layout, must be before DashboardTemplate */}
        <Route element={<PlatformLayout />}>
          <Route path="platform" element={<PlatformDashboard />} />
          <Route path="platform/companies" element={<PlatformCompaniesPage />} />
          <Route path="platform/users" element={<PlatformUsersPage />} />
          <Route path="platform/plans" element={<PlatformPlansPage />} />
          <Route path="platform/companies/:id" element={<PlatformCompanyDetailPage />} />
          <Route path="platform/profile" element={<ProfilePage platform />} />
        </Route>

        <Route element={<DashboardTemplate />}>
          <Route index element={<HomePage />} />
          <Route path="home" element={<RouteContext><HomePage /></RouteContext>} />
          <Route path="profile" element={<RouteContext><ProfilePage /></RouteContext>} />
          <Route path="jobs" element={<RouteContext><JobsPage /></RouteContext>} />
          <Route path="sales" element={<RouteContext><SalesPage /></RouteContext>} />
          <Route path="clients" element={<RouteContext><ClientsPage /></RouteContext>} />
          <Route path="clients/:id" element={<RouteContext><ClientDetailPage /></RouteContext>} />
          <Route path="profile" element={<RouteContext><ProfilePage /></RouteContext>} />
          <Route path="expenses" element={<RouteContext><ExpensesPage /></RouteContext>} />
          <Route path="payrolls" element={<RouteContext><PayrollsPage /></RouteContext>} />
          <Route path="cash-flow" element={<RouteContext><CashFlowPage /></RouteContext>} />
          <Route path="cash-flow-transactions" element={<RouteContext><CashFlowTransactionsPage /></RouteContext>} />
          <Route path="calendar" element={<RouteContext><CalendarPage /></RouteContext>} />
          <Route path="route-plan" element={<RouteContext><RoutePlanPage /></RouteContext>} />
          <Route path="reports/jobs-history" element={<RouteContext><JobReportsPage /></RouteContext>} />
          <Route path="reports/jobs-performance" element={<RouteContext><JobsPerformancePage /></RouteContext>} />
          <Route path="reports/expenses" element={<RouteContext><ExpensesReportsPage /></RouteContext>} />
          <Route path="reports/jobs-assignees" element={<RouteContext><JobAssignees /></RouteContext>} />
          <Route path="reports/services-reports" element={<RouteContext><ServicesReportsPage /></RouteContext>} />
          <Route path="reports/materials" element={<RouteContext><MaterialReportsPage /></RouteContext>} />
          <Route path="services" element={<RouteContext><ServicesPage /></RouteContext>} />
          <Route path="materials" element={<RouteContext><MaterialsPage /></RouteContext>} />
          <Route path="notifications" element={<RouteContext><NotificationsPage /></RouteContext>} />

          {/* Admin Pages */}
          <Route path="settings" element={<RouteContext><AdminPage /></RouteContext>} />
          <Route path="settings/company" element={<RouteContext><CompanyProfilePage /></RouteContext>} />
          <Route path="settings/users"element={<RouteContext><UsersPage /></RouteContext>} />
          <Route path="settings/employees"element={<RouteContext><EmployeesPage /></RouteContext>} />
          <Route path="settings/service-categories"element={<RouteContext><ServiceCategoriesPage /></RouteContext>} />
          <Route path="settings/expense-types"element={<RouteContext><ExpenseTypesPage /></RouteContext>} />
          <Route path="settings/badges" element={<RouteContext><BadgesPage /></RouteContext>} />

          <Route
            path="*"
            element={
              <NotFoundPage />
            }
          />
        </Route>
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        {/* Invitation link from Add User — the invitee sets their own password. */}
        <Route path="/accept-invite/:token" element={<AcceptInvitePage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        {/* Public customer self-entry form — no login, company resolved from the token. */}
        <Route path="/c/:token" element={<PublicIntakePage />} />
        {/* Private single-use enquiry link — same form, one customer. */}
        <Route path="/c/link/:token" element={<PublicIntakePage />} />
        {/* Customer tracking page — one job, one bearer link, no login. */}
        <Route path="/t/:token" element={<TrackPage />} />

      </Routes>
    </SocketContext.Provider>
    </>
  );
}

export default App;